/* Datumi su "zidno vreme" u lokalnoj zoni browsera; server prima/vraća datume bez zone.
   Odlazno: YYYY-MM-DD ili YYYY-MM-DD HH:mm. Dolazno: ISO bez Z -> Date (lokalno). */

const p2 = (n) => String(n).padStart(2, '0');

export const SR_LOCALE = {
    firstDayOfWeek: 1,
    dayNames: ['Nedelja', 'Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota'],
    dayNamesShort: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
    dayNamesMin: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
    monthNames: ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
    today: 'Danas',
    clear: 'Obriši',
    weekHeader: 'Ned',
    firstDay: 1,
};

export const startOfToday = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
};

export const addDays = (d, n) => {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
};

export const addMonths = (d, n) => {
    const x = new Date(d);
    x.setMonth(x.getMonth() + n);
    return x;
};

export const sameDay = (a, b) =>
    !!a && !!b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

/** YYYY-MM-DD (lokalno). */
export const toDateStr = (d) => {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    return `${x.getFullYear()}-${p2(x.getMonth() + 1)}-${p2(x.getDate())}`;
};

/** YYYY-MM-DD HH:mm (lokalno, bez zone). */
export const toDateTimeStr = (d) => {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    return `${toDateStr(x)} ${p2(x.getHours())}:${p2(x.getMinutes())}`;
};

/** DD.MM.YYYY (kao stari klijent, bez tačke na kraju). */
export const fmtDate = (d) => {
    if (!d) return '';
    const x = d instanceof Date ? d : new Date(d);
    return `${p2(x.getDate())}.${p2(x.getMonth() + 1)}.${x.getFullYear()}`;
};

export const fmtTime = (d) => {
    if (!d) return '';
    const x = d instanceof Date ? d : new Date(d);
    return `${p2(x.getHours())}:${p2(x.getMinutes())}`;
};

export const fmtDateTime = (d) => (d ? `${fmtDate(d)} ${fmtTime(d)}` : '');

/** Trajanje u ms -> HH:mm (sekunde se odsecaju, kao stari HH:mm format); tačno 24h se prikazuje kao 24:00. */
export const fmtDuration = (ms) => {
    const total = Math.floor((ms || 0) / 60000);
    return `${p2(Math.floor(total / 60))}:${p2(total % 60)}`;
};

export const DAY_MS = 86400000;

/** JSON reviver: ISO bez zone -> Date; 0001-01-01 -> null. */
const ISO_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/;
export const reviveDates = (key, value) => {
    if (typeof value === 'string' && ISO_RE.test(value)) {
        if (value.startsWith('0001-01-01')) return null;
        return new Date(value);
    }
    return value;
};

/** JSON.stringify replacer: Date -> 'YYYY-MM-DD HH:mm' (koristi this[key] jer Date.toJSON već pretvara u UTC). */
export function dateTimeReplacer(key, value) {
    const raw = this[key];
    if (raw instanceof Date) return toDateTimeStr(raw);
    return value;
}

export function dateReplacer(key, value) {
    const raw = this[key];
    if (raw instanceof Date) return toDateStr(raw);
    return value;
}

/** Serijalizuje objekat tako da su svi Date-ovi 'YYYY-MM-DD HH:mm'. */
export const withDateTimes = (obj) => JSON.parse(JSON.stringify(obj, dateTimeReplacer));
export const withDates = (obj) => JSON.parse(JSON.stringify(obj, dateReplacer));

export const MONTHS = SR_LOCALE.monthNames;

/** Naziv meseca ili raspona (za imena fajlova izveštaja). */
export const monthRangeLabel = (from, to) => {
    const a = MONTHS[from.getMonth()];
    const b = MONTHS[to.getMonth()];
    return a === b ? a : `${a}-${b}`;
};
